import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import StarRating from "./StarRating";
import { Server2 } from "../../redux/actions/auth/auth.actions";

const ReviewOrderModal = ({ show, onClose, order, isNew, handleOrderRating, orderRating }) => {

  const [reviews, setReviews] = useState({});
  const maxChars = 500;

  const handleRatingChange = (productId, rating) => {
    setReviews((prev) => ({
      ...prev,
      [productId]: {
        ...prev[productId],
        rating
      }
    }));
  };

  const handleReviewChange = (productId, text) => {
    if (text.length > maxChars) return;

    setReviews((prev) => ({
      ...prev,
      [productId]: {
        ...prev[productId],
        review: text
      }
    }));
  };

  const submitReviews = async () => {

    if(!allRated) return

    try {

      let config = {}

      const data = {
        orderId: order._id,
        buyerId: order.userId,
        orderRating,
        reviews: order.items.map((p) => ({
          orderProductId: p._id,
          productId: p.productId,
          sellerId: p.sellerId,
          rating: reviews[p.productId]?.rating || 0,
          review: reviews[p.productId]?.review || ""
        }))
      };

      if(isNew)
        config = {
          method: "post",
          url: Server2 + "/products/save-rating",
          data
        }

      else
        config = {
          method: "post",
          url: Server2 + "/products/update-rating",
          data
        }

    axios(config)
      .then(function (response) {
        if(response.status === 200) onClose();
      })
      .catch(function (error) {
        console.log(error);
      });

    } catch (err) {
      console.error(err);
    }
  };

  const allRated = order.items.every(
    (p) => reviews[p.productId]?.rating
  );

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>

      <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>

        <h6 className="mt-2 ">What do you enjoy most about your products, and how would you rate them overall?</h6>

        {order.items.map((product) => {

          const review = reviews[product.productId] || {};

          return (
            <div key={product.productId} className="card rounded p-3 mb-3"
            >

              {/* Product Info */}
              <div className="d-flex mb-3">

                <img
                  src={product.image}
                  alt=""
                  width={70}
                  height={70}
                  className="rounded me-3"
                  style={{ objectFit: "cover" }}
                />

                <div>
                  <div className="fw-semibold pb-0">
                    {product.productName}
                    <p className="text-muted small">
                      Seller: {order?.sellerOrders?.filter(seller =>  seller.sellerId === product.sellerId)[0]?.seller?.fname}
                    </p>
                  </div>
                  {/* Star Rating */}
                  <div className="d-flex align-items-center gap-2 mt-n2">
                    <StarRating
                      value={review.rating || 0}
                      onChange={(rating) =>
                        handleRatingChange(product.productId, rating)
                      }
                    />
                    {review.rating && (
                      <div className="small text-muted">
                        {review.rating} / 5
                      </div>
                    )}
                  </div>
                </div>

              </div>


              {/* Review Box */}
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Share your experience with this product..."
                value={review.review || ""}
                onChange={(e) =>
                  handleReviewChange(
                    product.productId,
                    e.target.value
                  )
                }
              />

              {/* Character Counter */}
              <div className="text-end small text-muted mt-1">
                {(review.review || "").length}/{maxChars}
              </div>

            </div>
          );
        })}


      </Modal.Body>

      <Modal.Footer>

        <div className="d-flex justify-content-between w-100">  
          <div className="d-flex align-items-center justify-content-end ps-2 gap-2">
            <p className="text-muted">Order rating: </p>
            <StarRating
              value={orderRating}
              onChange={(rating) => {handleOrderRating(rating)}}
            />
          </div>

          <div className="d-flex gap-2">
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>

            <Button
              className="btn ib-btn"
              onClick={submitReviews}
            >
              Submit Reviews
            </Button>

          </div>

        </div>

      </Modal.Footer>

    </Modal>
  );
};

export default ReviewOrderModal;